import { render, staticRenderFns } from "./ProcuratorsForm.vue?vue&type=template&id=01f533d8&"
import script from "./ProcuratorsForm.vue?vue&type=script&lang=js&"
export * from "./ProcuratorsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProcuratorsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports